﻿import { DataRequest } from 'shared/data/datarequest';

export class ValidationFailed {
    public constructor(public validationSummary: ValidationSummary) { }
}

export class WorkItemValidationFailed {
    public constructor(public validationSummary: ValidationSummary, public dataChanges: DataRequest[]) { }
}

export class ValidationItem {
    static pass = 'passed';
    static warn = 'passedwithwarnings';
    static fail = 'failed';

    constructor(public message: string, public messageDetail: string, public validationState: string) {}
}

export class ValidationResult extends ValidationItem {
}

export class ValidationSummary extends ValidationItem {
    constructor(public message: string, public messageDetail: string, public validationState: string, public validationItems: ValidationItem[]) {
        super(message, messageDetail, validationState);
    }

    firstFailureMessage() {
        const item = this.validationItems.find(x => x.validationState === ValidationItem.fail);
        return item ? item.message : undefined;
    }

    hasPassed() {
        return this.validationState === 'passed';
    }

    hasPassedWithWarnings() {
        return this.validationState === 'passedWithWarnings';
    }

    hasFailed() {
        return this.validationState === 'failed';
    }
}

export class ValidationSummaryAndDataChanges {
    constructor(public validationSummary: ValidationSummary, public dataChanges: DataRequest[]) {
    }
}